// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__ewOq2","rotate":"Checkbox_style_rotate__fYurr"};